import { render, staticRenderFns } from "./MarketplaceRatesModule.vue?vue&type=template&id=68ed9b14&scoped=true"
import script from "./MarketplaceRatesModule.vue?vue&type=script&lang=js"
export * from "./MarketplaceRatesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed9b14",
  null
  
)

export default component.exports